import { render, staticRenderFns } from "./SelectorIdcc.vue?vue&type=template&id=81649d08&"
import script from "./SelectorIdcc.vue?vue&type=script&lang=js&"
export * from "./SelectorIdcc.vue?vue&type=script&lang=js&"
import style0 from "./SelectorIdcc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports